export default __webpack_public_path__ + "static/media/Yasmeen.f893fa89.JPG";